import React from 'react';
import { TcsmInformationBlock } from '../../models/tcsm-block-models';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';


interface Props {
    blockData: TcsmInformationBlock,
}

export function TcsmInformationBlockView(props: Props){

    const { blockData } = props;        

    return (
        <section className="adage-block">            
            <WysiwygWithReactLink content={blockData?.content} />            
        </section>
    );
}

export default TcsmInformationBlockView;
